// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"tool-bar_toolbar__15fqu"};